import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-row" }
const _hoisted_2 = { class: "text-black" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { key: 2 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h3", { class: "pb-2" }, "Literaturliste", -1)
const _hoisted_11 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MoreInfo = _resolveComponent("MoreInfo")!
  const _component_CommentaryVerses = _resolveComponent("CommentaryVerses")!
  const _component_BackToTop = _resolveComponent("BackToTop")!
  const _component_ArticleContainer = _resolveComponent("ArticleContainer")!

  return (_openBlock(), _createBlock(_component_ArticleContainer, {
    id: _ctx.section.id,
    class: "showTable"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("h2", _hoisted_2, [
              _createElementVNode("span", {
                innerHTML: _ctx.section.general_title
              }, null, 8, _hoisted_3),
              (_ctx.section.general_title && _ctx.section.specific_title)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, ": "))
                : _createCommentVNode("", true),
              _createElementVNode("span", {
                innerHTML: _ctx.section.specific_title
              }, null, 8, _hoisted_5)
            ]),
            (_ctx.section.comment_title)
              ? (_openBlock(), _createBlock(_component_MoreInfo, {
                  key: 0,
                  showInfo: _ctx.showInfo,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showInfo = !_ctx.showInfo)),
                  class: "ml-4"
                }, null, 8, ["showInfo"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass([_ctx.showInfo ? 'max-h-large' : 'max-h-0', "text-m overflow-hidden transition transition-maxHeight ease-in-out duration-700"])
          }, [
            _createElementVNode("div", {
              class: "bg-grey-verylight px-3 py-5 mt-7",
              innerHTML: _ctx.section.comment_title
            }, null, 8, _hoisted_6)
          ], 2)
        ])
      ]),
      _hoisted_7,
      (_ctx.section.content)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            innerHTML: _ctx.section.content,
            class: "pb-6"
          }, null, 8, _hoisted_8))
        : _createCommentVNode("", true),
      (_ctx.section.verse_content)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.section.verse_content, (comment) => {
            return (_openBlock(), _createBlock(_component_CommentaryVerses, {
              key: comment.content,
              commentary: comment,
              sectionId: _ctx.section.id
            }, null, 8, ["commentary", "sectionId"]))
          }), 128))
        : _createCommentVNode("", true),
      (_ctx.section.works_cited)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", {
              innerHTML: _ctx.section.works_cited
            }, null, 8, _hoisted_11)
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_BackToTop)
    ]),
    _: 1
  }, 8, ["id"]))
}